// Unscheduled / plan-mode panel for the Plan page rail.
import Panel from '@/components/ui/Panel';
import TaskList from '@/features/tasks/components/lists/TaskList';
import { AddTaskRow } from '@/components/ui/AddTaskRow';
import { useT } from '@/i18n/useT';
import {
  PANEL_FLAT_CLASS,
  PLAN_PANEL_A11Y,
  planRailListTabProps,
} from '@/features/planning/components/shared/planRailPanelShared';

export default function PlanRailUnscheduledPanel({
  planMode,
  unscheduledTasks,
  planRailTasks,
  unscheduledListTasks,
  selectedTaskIds,
  railSelectionHandlers,
  focusOwnerId,
  unscheduledHighlightId,
  onboardingHighlightAddTask,
  onOnboardingAddTaskUsed,
  projectStateProps,
}) {
  const t = useT();
  return (
    <Panel
      flat
      contentClassName={PANEL_FLAT_CLASS}
      testId="panel-unscheduled"
      title={
        planMode
          ? t('plan.planModeRailTitle', 'Plan')
          : t('plan.unscheduled', 'To schedule')
      }
      count={(planMode ? planRailTasks : unscheduledTasks)?.length || 0}
      {...PLAN_PANEL_A11Y}
    >
      <TaskList
        tasks={unscheduledListTasks}
        selectedTaskIds={selectedTaskIds}
        onSelectionChange={railSelectionHandlers.unscheduled}
        listId="unscheduled"
        focusOwnerId={focusOwnerId}
        view="plan"
        planMode={planMode}
        menuSurface="plan-rail"
        indentationType="full"
        showBreadcrumbs
        addSubtaskOnParentsOnly
        dragEnabled
        onboardingHighlightTaskId={unscheduledHighlightId}
        {...projectStateProps}
        {...planRailListTabProps(unscheduledListTasks)}
      />
      <AddTaskRow
        tasks={unscheduledListTasks}
        tabIndex={-1}
        highlight={onboardingHighlightAddTask}
        onOpen={onOnboardingAddTaskUsed}
      />
    </Panel>
  );
}
